import { useEffect, useRef, useState } from 'react';

/**
 * Natural sizes of the images used by image nodes, keyed by URL:
 * `{ width, height }` once loaded, `{ error: true }` when the image cannot be loaded.
 */
export default function useImageSizes(nodes) {
  const [sizes, setSizes] = useState({});
  const pending = useRef(new Set());

  useEffect(() => {
    nodes.forEach((node) => {
      const src = node.shape === 'image' ? node.image : null;
      if (!src || sizes[src] || pending.current.has(src)) return;
      pending.current.add(src);
      const img = new Image();
      img.onload = () => {
        pending.current.delete(src);
        setSizes((prev) => ({
          ...prev,
          [src]: { width: img.naturalWidth || 1, height: img.naturalHeight || 1 },
        }));
      };
      img.onerror = () => {
        pending.current.delete(src);
        setSizes((prev) => ({ ...prev, [src]: { error: true } }));
      };
      img.src = src;
    });
  }, [nodes, sizes]);

  return sizes;
}
